import { ReactNode, useEffect, useRef } from "react";
import styled from "styled-components";
import { FieldButton } from "components/voc";

type AlertModalProps = {
  title: ReactNode;
  desc?: ReactNode;
  show: boolean;
  onClose: () => void;
};

const AlertModalWrapper = styled.div`
  .modal_popup {
    z-index: 10;
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0 3rem;
    background-color: rgba(68, 68, 68, 0.7);
  }
  .modal_popup.-active {
    display: flex;
  }
  .modal_popup .modal_inner {
    width: 100%;
    padding: 3rem 3rem 0;
    background-color: #fff;
    border-radius: 1rem;
  }
  .modal_popup .modal_content .txt_desc {
    white-space: pre-line;
    word-break: keep-all;
  }
  .modal_popup.-notitle .modal_content {
    line-height: 2.2rem;
    letter-spacing: -0.04em;
    text-align: center;
  }
  .modal_popup.-notitle .modal_content .txt_red {
    margin-top: 0.4rem;
    color: #e92319;
    font-weight: 400;
  }
  .modal_popup .modal_btn_page_bottom {
    margin-top: 2.3rem;
    border-top: 1px solid #dadada;
    text-align: center;
  }
  .modal_popup .modal_btn_page_bottom .btn_alert_close {
    padding: 2rem;
    text-align: center;
    font-weight: 700;
    line-height: 2.2rem;
    letter-spacing: -0.04em;
  }
`;

const AlertModal = ({ title, desc, show, onClose }: AlertModalProps) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const handleModal = {
    show: () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      const modal = modalRef.current!;
      modal.classList.add("-active");
      setTimeout(() => {
        document.body.style.overflow = "hidden";
      }, 100);
    },
    hide: () => {
      const modal = modalRef.current!;
      modal.classList.remove("-active");
      document.body.style.overflow = "";
    },
  };

  useEffect(() => {
    if (show) {
      handleModal.show();
    } else {
      handleModal.hide();
    }
  }, [show]);

  return (
    <>
      <AlertModalWrapper>
        <div className="modal_popup -notitle" ref={modalRef}>
          <div className="modal_inner">
            <div className="modal_content">
              <strong className="txt_desc">{title}</strong>
              <p className="txt_desc">{desc}</p>
            </div>
            <div className="modal_btn_page_bottom">
              <FieldButton type="button" className="btn_alert_close" onClick={onClose}>
                확인
              </FieldButton>
            </div>
          </div>
        </div>
      </AlertModalWrapper>
    </>
  );
};

export default AlertModal;
